import { DomainOrderByKey } from 'src/app/graphql/gql';
import { ColumnDefinition } from 'src/app/paginated-table/paginated-table.component';

export const COLUMN_DEFINITIONS: ColumnDefinition<DomainOrderByKey>[] = [
  {
    attr: 'owner.clientNumber',
    label: $localize`:domains|Account client number column:Account Client Number`
  },
  {
    attr: 'owner.company',
    label: $localize`:domains|Account company name column:Account Company Name`
  },
  {
    attr: 'name',
    label: $localize`:domains|Domain name column:Name`,
    orderKey: DomainOrderByKey.Name,
    width: 200
  },
  {
    attr: 'idn',
    label: $localize`:domains|IDN column:IDN`,
    visible: false
  },
  {
    attr: 'basename',
    label: $localize`:domains|Basename column:Basename`,
    visible: false
  },
  {
    attr: 'tld.name',
    label: $localize`:domains|TLD column:TLD`
  },
  {
    attr: 'department.name',
    label: $localize`:domains|Division column:Division`
  },
  {
    attr: 'brand.name',
    label: $localize`:domains|Brand column:Brand`,
    orderKey: DomainOrderByKey.Brand,
  },
  {
    attr: 'state',
    label: $localize`:domains|State column:State`
  },
  {
    attr: 'expiresAt',
    label: $localize`:domains|Expires at column:Expires at`,
    cellType: 'date'
  },
  {
    attr: 'transferredAt',
    label: $localize`:domains|Transferred at column:Transferred at`,
    cellType: 'date',
    visible: false
  },
  {
    attr: 'updatedAt',
    label: $localize`:domains|Updated at column:Updated at`,
    cellType: 'date',
    visible: false
  },
  {
    attr: 'transferLock',
    label: $localize`:domains|Transfer lock column:Transfer lock`,
    cellType: 'boolean',
    visible: false
  },
  {
    attr: 'updateLock',
    label: $localize`:domains|Update lock column:Update lock`,
    cellType: 'boolean',
    visible: false
  },
  {
    attr: 'deleteLock',
    label: $localize`:domains|Delete lock column:Delete lock`,
    cellType: 'boolean',
    visible: false
  },
  {
    attr: 'clientManaged',
    label: $localize`:domains|Client managed column:Client managed`,
    cellType: 'boolean',
    visible: false
  },
  {
    attr: 'renewalMode',
    label: $localize`:domains|Renewal mode column:Renewal mode`
  },
  {
    attr: 'premium',
    label: $localize`:domains|Premium column:Premium`,
    cellType: 'boolean'
  },
  {
    attr: 'supportsAuthcode',
    label: $localize`:domains|Supports authcode column:Supports authcode`,
    cellType: 'boolean',
    visible: false
  },
  {
    attr: 'whoisPrivacy',
    label: $localize`:domains|Whois privacy column:Whois privacy`,
    cellType: 'boolean',
    visible: false
  },
  {
    attr: 'costUnit',
    label: $localize`:domains|Cost unit column:Cost unit`,
    visible: false
  },
  {
    attr: 'adminContact.handle',
    label: $localize`:domains|Admin contact handle column:Admin Contact: Handle`,
    visible: false
  },
  {
    attr: 'adminContact.title',
    label: $localize`:domains|Admin contact title column:Admin Contact: Title`,
    visible: false
  },
  {
    attr: 'adminContact.firstname',
    label: $localize`:domains|Admin contact firstname column:Admin Contact: Firstname`,
    visible: false
  },
  {
    attr: 'adminContact.lastname',
    label: $localize`:domains|Admin contact lastname column:Admin Contact: Lastname`,
    visible: false
  },
  {
    attr: 'adminContact.fax',
    label: $localize`:domains|Admin contact fax column:Admin Contact: Fax`,
    visible: false
  },
  {
    attr: 'adminContact.street',
    label: $localize`:domains|Admin contact street column:Admin Contact: Street`,
    visible: false
  },
  {
    attr: 'adminContact.street1',
    label: $localize`:domains|Admin contact street line1 column:Admin Contact: Street (additional line 1)`,
    visible: false
  },
  {
    attr: 'adminContact.street2',
    label: $localize`:domains|Admin contact street line2 column:Admin Contact: Street (additional line 2)`,
    visible: false
  },
  {
    attr: 'adminContact.company',
    label: $localize`:domains|Admin contact company column:Admin Contact: Company`,
    visible: false
  },
  {
    attr: 'adminContact.city',
    label: $localize`:domains|Admin contact city column:Admin Contact: City`,
    visible: false
  },
  {
    attr: 'adminContact.zip',
    label: $localize`:domains|Admin contact zip column:Admin Contact: Zip`,
    visible: false
  },
  {
    attr: 'adminContact.phone',
    label: $localize`:domains|Admin contact phone column:Admin Contact: Phone`,
    visible: false
  },
  {
    attr: 'adminContact.countryState',
    label: $localize`:domains|Admin contact country state column:Admin Contact: Country state`,
    visible: false
  },
  {
    attr: 'adminContact.email',
    label: $localize`:domains|Admin contact email column:Admin Contact: Email`,
    visible: false
  },
  {
    attr: 'ownerContact.handle',
    label: $localize`:domains|Owner contact handle column:Owner Contact: Handle`,
    visible: false
  },
  {
    attr: 'ownerContact.title',
    label: $localize`:domains|Owner contact title column:Owner Contact: Title`,
    visible: false
  },
  {
    attr: 'ownerContact.firstname',
    label: $localize`:domains|Owner contact firstname column:Owner Contact: Firstname`,
    visible: false
  },
  {
    attr: 'ownerContact.lastname',
    label: $localize`:domains|Owner contact lastname column:Owner Contact: Lastname`,
    visible: false
  },
  {
    attr: 'ownerContact.fax',
    label: $localize`:domains|Owner contact fax column:Owner Contact: Fax`,
    visible: false
  },
  {
    attr: 'ownerContact.street',
    label: $localize`:domains|Owner contact street column:Owner Contact: Street`,
    visible: false
  },
  {
    attr: 'ownerContact.street1',
    label: $localize`:domains|Owner contact street line1 column:Owner Contact: Street (additional line 1)`,
    visible: false
  },
  {
    attr: 'ownerContact.street2',
    label: $localize`:domains|Owner contact street line2 column:Owner Contact: Street (additional line 2)`,
    visible: false
  },
  {
    attr: 'ownerContact.company',
    label: $localize`:domains|Owner contact company column:Owner Contact: Company`,
    visible: false
  },
  {
    attr: 'ownerContact.city',
    label: $localize`:domains|Owner contact city column:Owner Contact: City`,
    visible: false
  },
  {
    attr: 'ownerContact.zip',
    label: $localize`:domains|Owner contact zip column:Owner Contact: Zip`,
    visible: false
  },
  {
    attr: 'ownerContact.phone',
    label: $localize`:domains|Owner contact phone column:Owner Contact: Phone`,
    visible: false
  },
  {
    attr: 'ownerContact.countryState',
    label: $localize`:domains|Owner contact country state column:Owner Contact: Country state`,
    visible: false
  },
  {
    attr: 'ownerContact.email',
    label: $localize`:domains|Owner contact email column:Owner Contact: Email`,
    visible: false
  },
  {
    attr: 'techContact.handle',
    label: $localize`:domains|Technical contact handle column:Technical Contact: Handle`,
    visible: false
  },
  {
    attr: 'techContact.title',
    label: $localize`:domains|Technical contact title column:Technical Contact: Title`,
    visible: false
  },
  {
    attr: 'techContact.firstname',
    label: $localize`:domains|Technical contact firstname column:Technical Contact: Firstname`,
    visible: false
  },
  {
    attr: 'techContact.lastname',
    label: $localize`:domains|Technical contact lastname column:Technical Contact: Lastname`,
    visible: false
  },
  {
    attr: 'techContact.fax',
    label: $localize`:domains|Technical contact fax column:Technical Contact: Fax`,
    visible: false
  },
  {
    attr: 'techContact.street',
    label: $localize`:domains|Technical contact street column:Technical Contact: Street`,
    visible: false
  },
  {
    attr: 'techContact.street1',
    label: $localize`:domains|Technical contact street line1 column:Technical Contact: Street (additional line 1)`,
    visible: false
  },
  {
    attr: 'techContact.street2',
    label: $localize`:domains|Technical contact street line2 column:Technical Contact: Street (additional line 2)`,
    visible: false
  },
  {
    attr: 'techContact.company',
    label: $localize`:domains|Technical contact company column:Technical Contact: Company`,
    visible: false
  },
  {
    attr: 'techContact.city',
    label: $localize`:domains|Technical contact city column:Technical Contact: City`,
    visible: false
  },
  {
    attr: 'techContact.zip',
    label: $localize`:domains|Technical contact zip column:Technical Contact: Zip`,
    visible: false
  },
  {
    attr: 'techContact.phone',
    label: $localize`:domains|Technical contact phone column:Technical Contact: Phone`,
    visible: false
  },
  {
    attr: 'techContact.countryState',
    label: $localize`:domains|Technical contact country state column:Technical Contact: Country state`,
    visible: false
  },
  {
    attr: 'techContact.email',
    label: $localize`:domains|Technical contact email column:Technical Contact: Email`,
    visible: false
  },
  {
    attr: 'billingContact.handle',
    label: $localize`:domains|Billing contact handle column:Billing Contact: Handle`,
    visible: false
  },
  {
    attr: 'billingContact.title',
    label: $localize`:domains|Billing contact title column:Billing Contact: Title`,
    visible: false
  },
  {
    attr: 'billingContact.firstname',
    label: $localize`:domains|Billing contact firstname column:Billing Contact: Firstname`,
    visible: false
  },
  {
    attr: 'billingContact.lastname',
    label: $localize`:domains|Billing contact lastname column:Billing Contact: Lastname`,
    visible: false
  },
  {
    attr: 'billingContact.fax',
    label: $localize`:domains|Billing contact fax column:Billing Contact: Fax`,
    visible: false
  },
  {
    attr: 'billingContact.street',
    label: $localize`:domains|Billing contact street column:Billing Contact: Street`,
    visible: false
  },
  {
    attr: 'billingContact.street1',
    label: $localize`:domains|Billing contact street line1 column:Billing Contact: Street (additional line 1)`,
    visible: false
  },
  {
    attr: 'billingContact.street2',
    label: $localize`:domains|Billing contact street line2 column:Billing Contact: Street (additional line 2)`,
    visible: false
  },
  {
    attr: 'billingContact.company',
    label: $localize`:domains|Billing contact company column:Billing Contact: Company`,
    visible: false
  },
  {
    attr: 'billingContact.city',
    label: $localize`:domains|Billing contact city column:Billing Contact: City`,
    visible: false
  },
  {
    attr: 'billingContact.zip',
    label: $localize`:domains|Billing contact zip column:Billing Contact: Zip`,
    visible: false
  },
  {
    attr: 'billingContact.phone',
    label: $localize`:domains|Billing contact phone column:Billing Contact: Phone`,
    visible: false
  },
  {
    attr: 'billingContact.countryState',
    label: $localize`:domains|Billing contact country state column:Billing Contact: Country state`,
    visible: false
  },
  {
    attr: 'billingContact.email',
    label: $localize`:domains|Billing contact email column:Billing Contact: Email`,
    visible: false
  },
]